import * as React from 'react';
import {Loader, Dropdown, DropdownItemProps } from '@fluentui/react-northstar';
import {TeamsMonochromeIcon, TenantPersonalIcon, } from '@fluentui/react-icons-northstar';
import { CaseType } from '../helpers/constants';
import axios from 'axios';
import * as Functions from '../helpers/Functions';
import { HttpRequest } from '../helpers/HttpRequest';
class SearchBox extends React.Component<ISearchBoxProps, ISearchBoxState> {
    constructor(props) {
        super(props);
        this.handleSearchQueryChanged = this.handleSearchQueryChanged.bind(this);
        this.handleSearchDidChanged = this.handleSearchDidChanged.bind(this);
        this.state = { items: [], isSearching: false, charsCount: 0 };
    }
    componentDidMount() {
        switch (this.props.type) {
            case CaseType.matter: case CaseType.litigation: fullURL = "/modules/api/cases/autocomplete"; break;
            case CaseType.hearing: fullURL = "/modules/api/hearings/list_hearings"; break;
            case CaseType.contract: fullURL = "/modules/api/contracts/autocomplete"; break;
            case 'Invitation': fullURL = "/modules/api/contacts/autocomplete"; break;
            case 'Organization': {
                axios.get('/Cases/GetOrganizationMembers')
                    .then(response => {
                        var members = response.data;
                        var items = [];
                        members.forEach(member => {
                            items.push({
                                key: member.id,
                                header: member.name,
                                content: member.mail,
                                type: 'member',
                                media: < TeamsMonochromeIcon alt='Organization member' />,
                                checked: true
                            });
                        });
                        this.setState({ items: items });
                    });
            } break;
        }
    }
    async handleSearchQueryChanged(e, data) {
        this.setState({ charsCount: data.searchQuery.length });
        if (data.searchQuery.length >= 3) {
            this.setState({ items: [], isSearching: true });
            var dataToPost = 'term=' + data.searchQuery;
            if (this.props.type == CaseType.matter || this.props.type == CaseType.litigation)
                dataToPost += '&category=Litigation_Matter'
            var response = await HttpRequest.post(fullURL, dataToPost);
            if (response) {
                var content = response.data.success.data;
                var items = [];
                if (content) {
                    switch (this.props.type) {
                        case CaseType.matter: case CaseType.litigation:
                            {
                                content.forEach(item => {
                                    if (item.subject.toLowerCase().includes(data.searchQuery.toLowerCase()) || item.id.includes(data.searchQuery.substring(1, data.searchQuery.length))) {
                                        items.push(
                                            {
                                                key: String(item.id),
                                                header: String('M' + Number(item.id) + ': ' + Functions.strip_html_tags(item.subject)),
                                                content: String((item.category == 'Matter') ? CaseType.matter : CaseType.litigation),
                                                image: { src: require('../Images/' + item.category + '.svg') }
                                            });
                                    }
                                });
                            } break;
                        case CaseType.hearing:
                            {
                                content.forEach(item => {
                                    if (item.caseSubject.toLowerCase().includes(data.searchQuery.toLowerCase())) {
                                        var hearingDate = '[';
                                        var startDate = item.startDate;
                                        var startTime = (item.startTime)?.substring(0, 5);
                                        if (startDate != null) {
                                            hearingDate += startDate;
                                        }
                                        if (startTime != null) {
                                            hearingDate += ' ' + startTime;
                                        }
                                        hearingDate += ']';
                                        items.push(
                                            {
                                                key: String(item.id + ':' + item.legal_case_id),
                                                header: String(Functions.strip_html_tags(item.caseSubject) + ' ' + hearingDate + ' ' + ((item.type_name_en != null) ? item.type_name_en : "")),
                                                content: String(CaseType.hearing),
                                                image: { src: require('../Images/hearingdetails.png') }
                                            });
                                    }
                                });
                            } break;
                        case CaseType.contract:
                            {
                                content.forEach(item => {
                                    items.push(
                                        {
                                            key: String(item.id),
                                            header: String(item.contract_id + ": " + Functions.strip_html_tags(item.name)),
                                            content: String(CaseType.contract),
                                            image: { src: require('../Images/' + CaseType.contract + '.svg') }
                                        });
                                });
                            } break;
                        case 'Invitation':
                            {
                                content.forEach(item => {
                                    items.push(
                                        {
                                            key: String(item.id),
                                            header: String(item.name),
                                            type: "contact",
                                            media: <TenantPersonalIcon alt='Contacts' />,
                                            checked: true
                                        });
                                });
                            } break;
                        default: break;
                    }
                }
                this.setState({ items: items, isSearching: false });
            }
        }
    }
    handleSearchDidChanged(e, data) {
        this.props.onSelectItem(data);
    }
    getFieldType(type) {
        switch (type) {
            case CaseType.matter: case CaseType.litigation: return
        }
    }
    render() {

        const divStyle = {
            width: '100%'
        };
        const loadingMessage = this.state.items.length > 0 ? (this.state.items.length == 1 ? '1 Result found' : this.state.items.length + ' Results found') : 'No results found';
        return (
            <div style={divStyle}>
                <Dropdown
                    search
                    multiple={this.props.isMultiple}
                    fluid
                    items={this.state.items}
                    loading
                    loadingMessage={this.props.type == 'Organization' ? null : this.state.charsCount < 3 ? 'To get results you have to enter minimum 3 letters/numbers' : this.state.isSearching ? { content: <Loader size='smallest' /> } : loadingMessage}
                    placeholder="Start typing..."
                    noResultsMessage="We couldn't find any matches."
                    onSearchQueryChange={this.props.type == 'Organization' ? null : this.handleSearchQueryChanged}
                    clearable={!this.props.isSearching}
                    toggleIndicator={null}
                    onChange={this.handleSearchDidChanged}
                />
            </div>
        );
    }
}
export default SearchBox;
var fullURL = "";
//const[loading] = useBooleanKnob({
//    name: 'loading',
//    initialValue: true,
//});
interface ISearchBoxProps {
    type: string;    
    items: string[];
    onSelectItem(data);
    isSearching: boolean;
    isMultiple: boolean;
    errorAPI(code);
}
interface ISearchBoxState {
    items: DropdownItemProps[];    
    isSearching: boolean;
    charsCount: number;
}